import React, { useCallback } from "react";
import { ModuleSection, SectionItem } from "./type";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import CheckIcon from "@mui/icons-material/Check";
import ListItemText from "@mui/material/ListItemText";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Box from "@mui/material/Box";
import { completeBoxStyle, completeIconStyle, subheader, item } from "./style";
import { useNavigate } from "react-router-dom";
import { ONBOARDING_PATH, ROOT_PATH } from "../../../../routes/constants";
import { ListSubheader } from "@mui/material";
import { useQuery } from "../../../../utils/hooks/use-query";
import { OnboardingExamRegistryStatus } from "../../types";
import Icon from "../../../../components/icon/icon";
import { SvgAssets } from "../../../../components/icon/assets";

type MenuListProps = {
  sections?: ModuleSection[];
};

export const MenuList = (props: MenuListProps) => {
  const { sections = [] } = props;
  const navigate = useNavigate();
  const query = useQuery();

  const getItemClickHandler = useCallback(
    (d: SectionItem) => {
      if (
        [OnboardingExamRegistryStatus.FAILED, OnboardingExamRegistryStatus.PASSED].includes(
          d.status as any,
        )
      ) {
        navigate(
          `${ROOT_PATH}/${ONBOARDING_PATH}/exams/registry/${
            d.data.id
          }/feedback?${query.toString()}`,
          {
            state: { exam: d.data },
          },
        );
      } else {
        navigate(
          `${ROOT_PATH}/${ONBOARDING_PATH}/exams/registry/${d.data.id}?${query.toString()}`,
          {
            state: { data: d.data },
          },
        );
      }
    },
    [navigate, query],
  );

  return (
    <div className="px-4">
      <List>
        {sections.map((section) => {
          return (
            <div key={section.name}>
              <ListSubheader sx={subheader}>
                <ListItemText primary={section.title} />
              </ListSubheader>
              <List>
                {section.data.map((d) => {
                  return (
                    <div key={d.name} className="bg-white mb-3 rounded-xl">
                      <ListItemButton
                        sx={{ backgroundColor: "white" }}
                        onClick={() => getItemClickHandler(d)}
                      >
                        <ListItemText sx={item} primary={d.title} />
                        <StatusIcon status={d.status}></StatusIcon>
                      </ListItemButton>
                    </div>
                  );
                })}
              </List>
            </div>
          );
        })}
      </List>
    </div>
  );
};

const StatusIcon = ({ status }: { status?: keyof typeof OnboardingExamRegistryStatus }) => {
  switch (status) {
    case OnboardingExamRegistryStatus.REGISTERED:
    case OnboardingExamRegistryStatus.FOLLOWUP_REQUIRED_REGISTERED:
    case OnboardingExamRegistryStatus.PASSED:
      return (
        <Box sx={completeBoxStyle}>
          <CheckIcon sx={completeIconStyle} />
        </Box>
      );
    case OnboardingExamRegistryStatus.FAILED:
      return <Icon svg={SvgAssets.failure} height={32} width={32} />;
    default:
      return <ChevronRightIcon />;
  }
  return <></>;
};
